export default "__VITE_ASSET__$tfF0Ieb__"